<app-shell>

  <router-outlet></router-outlet>
  <app-contact></app-contact>

</app-shell>
